/**
 * /app/trusts/$id/companies/$companyId — the §16 company assets view (route shell).
 *
 * Screen impl in `./company-assets-screen.tsx`, lazy-loaded via
 * `lazyRouteComponent`. Reached from the trust assets tab's ownership-chain line
 * ("Holds shares in <Company> → which owns <N assets>") — shows the assets a
 * company the trust holds owns. A deep sub-route (not first-paint), so the body
 * leaves the entry bundle. Flat-file route name mirrors the sibling
 * `./document-review.$jobId.tsx`; the committed routeTree.gen.ts imports only
 * `Route` from here, so no plugin regen is needed.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/companies/$companyId')({
  component: lazyRouteComponent(() => import('./company-assets-screen'), 'CompanyAssetsScreen'),
});
